<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">
    <font color="#0063b9" style="font-size: 16px"
      ><i
        class="fa-light fa-building-columns"
        style="margin-right: 10px; font-size: 25px"
      ></i>
      Seleccione un banco</font
    >
  </h5>
  <button type="button" class="btn-close" (click)="close()">
    <i class="fas fa-times-circle" style="color: #0063b9"></i>
  </button>
</div>
<div class="modal-body">
  <div class="text-center">
    <div class="row" *ngIf="loadbank">
      <div class="col-sm-12">
        <div
          class="alert alert-outline-primary"
          style="font-size: 20px; color: #0063b9"
          role="alert"
        >
          <div align="center">
            <h5>Conectando al sistema de pago.</h5>
          </div>
          <hr />
        </div>
      </div>

      <div
        class="col-sm-12 flex justify-content-center"
        style="margin-bottom: 20px"
      >
        <div
          class="spinner-border text-primary"
          style="width: 80px; height: 80px"
          role="status"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div
        class="col-sm-12 flex justify-content-center"
        style="margin-bottom: 20px"
      >
        <img
          style="width: 20%"
          src="https://www.khipu.com/wp-content/uploads/2022/03/08-Khipu-200x75-1.svg"
        />
      </div>

      <div class="col-sm-12" align="center" style="font-size: 20px">
        <hr />
        Procesando pago ...
      </div>
    </div>

    <div *ngIf="!loadbank" class="table-responsive">
      <table class="tabla-dias table table-sm table-borderless">
        <tbody>
          <ng-container *ngFor="let item of listaBancos; let i = index">
            <tr class="dia-container-habilitado">
              <div
                [ngClass]="
                  index_banco == i
                    ? 'dia-container-activado'
                    : 'dia-container-desactivado'
                "
                (click)="Selecciona_Banco(item, i)"
              >
                <td style="width: 60%" align="justify">
                  <div class="row">
                    <div
                      class="col-lg-12 flex justify-content-start"
                      style="
                        font-size: 14px;
                        color: #0063b9;
                        white-space: nowrap;
                      "
                    >
                      <i
                        class="fa fa-credit-card"
                        aria-hidden="true"
                        style="margin-right: 10px; margin-top: 3px"
                        [ngStyle]="{
                          color: index_banco == i ? '#118565' : '#D1D1D1'
                        }"
                      ></i>
                      <strong>{{ item.name }}</strong>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="row text-end">
                    <div
                      class="col-lg-12"
                      style="
                        font-size: 13px;
                        color: #0063b9;
                        font-weight: bold;
                      "
                    >
                      Monto minimo
                    </div>
                    <div
                      class="col-lg-12"
                      style="font-size: 16px; color: #0063b9"
                    >
                      {{ item.minAmount | currency }}
                    </div>
                  </div>
                </td>
              </div>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div *ngIf="!loadbank" class="modal-footer">
  <button
    type="button"
    [disabled]="!selectbank"
    (click)="Pagar()"
    class="btn btn-secondary btn-lg w-100 text-center"
  >
    Ir a pagar
  </button>
</div>
